import { motion } from "framer-motion";
import { MARQUEE } from "@/data/content";

export default function Marquee() {
  const items = [...MARQUEE, ...MARQUEE, ...MARQUEE, ...MARQUEE];
  return (
    <section
      className="relative border-y border-white/5 py-10 md:py-14 bg-[#0A0A0F] overflow-hidden"
      data-testid="marquee-section"
    >
      <div className="flex overflow-hidden no-scrollbar">
        <div className="flex marquee-track whitespace-nowrap will-change-transform">
          {items.map((t, i) => (
            <span
              key={i}
              className="mx-8 md:mx-12 font-serif italic text-4xl md:text-6xl lg:text-7xl text-white/90 flex items-center"
            >
              {t}
              <span className="mx-8 md:mx-12 inline-block w-3 h-3 md:w-4 md:h-4 rounded-full gradient-bg" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}

export function SectionEyebrow({ n, children, testId }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: [0.8, 0, 0.2, 1] }}
      className="flex items-baseline gap-4"
      data-testid={testId}
    >
      {n && <span className="font-serif text-2xl md:text-3xl text-white/40">{n}</span>}
      <span className="eyebrow gradient-text">{children}</span>
    </motion.div>
  );
}
